import { techDataSections } from "../../configs/TechnicalDataEnums";

const baseUrl = process.env.REACT_APP_API_URL + "/api";
const layersUrl = baseUrl + "/layers";

const baseUrl2 = process.env.REACT_APP_ENERGY_DASHBOARD_API_URL + "/api";

export default {
  buildingPassport: {
    detail: (fileId) => `${baseUrl}/floor_interaction/${fileId}/`,
    download: (projectId) => `${layersUrl}/get_files_of_floors_plan/?project_id=${projectId}`,
    list: (projectId) => `${layersUrl}/get_all_floors_plan_of_floors_layer/?project_id=${projectId}`,
    uploadFile: `${baseUrl}/floor_file_interaction/`,
    uploadFileMetaData: `${baseUrl}/floor_interaction/`,
  },
  techData: {
    notExistedYet: {
      list: (projectId) => `${layersUrl}/notExistedYet/?project_id=${projectId}`,
    },
    [techDataSections.COOLING_SYSTEM]: {
      detail: (rowId) => `${baseUrl2}/cooling-systems/${rowId}`,
      list: (projectId) => `${baseUrl2}/cooling-systems/filter?projectId=${projectId}`,
      paginated: true,
      post: () => `${baseUrl2}/cooling-systems`,
    },
    [techDataSections.ENERGY_MIX]: {
      detail: (rowId) => `${baseUrl}/energy_mix/${rowId}/`,
      list: (projectId) => `${baseUrl}/energy_mix/?project_id=${projectId}`,
      post: () => `${baseUrl}/energy_mix/`,
    },
    [techDataSections.HEATING_SYSTEM]: {
      detail: (rowId) => `${baseUrl2}/heating-systems/${rowId}`,
      list: (projectId) => `${baseUrl2}/heating-systems/filter?projectId=${projectId}`,
      paginated: true,
      post: () => `${baseUrl2}/heating-systems`,
    },
    [techDataSections.HOT_WATER]: {
      detail: (rowId) => `${baseUrl2}/hot-water-systems/${rowId}`,
      list: (projectId) => `${baseUrl2}/hot-water-systems/filter?projectId=${projectId}`,
      paginated: true,
      post: () => `${baseUrl2}/hot-water-systems`,
    },
    [techDataSections.INFILTRATION]: {
      detail: (rowId) => `${baseUrl2}/infiltrations/${rowId}`,
      list: (projectId) => `${baseUrl2}/infiltrations/filter?projectId=${projectId}`,
      paginated: true,
      post: () => `${baseUrl2}/infiltrations`,
    },
    [techDataSections.PV_SYSTEM]: {
      detail: (rowId) => `${baseUrl2}/pv-panel/${rowId}`,
      list: (projectId) => `${baseUrl2}/pv-panel/filter?projectId=${projectId}`,
      paginated: true,
      post: () => `${baseUrl2}/pv-panel`,
    },
    [techDataSections.ROOFTOP]: {
      detail: (rowId) => `${baseUrl}/rooftop_interaction/${rowId}/`,
      downloadAll: (projectId) =>
        `${layersUrl}/get_whole_files_of_envelop_type/?project_id=${projectId}&envelop_type=rooftop/`,
      downloadLayer: (projectId, layerId) =>
        `${layersUrl}/get_files_layer_zip_files_of_specific_envelop/?project_id=${projectId}&layer_id=${layerId}&layer_type=rooftop/`,
      layerDetail: (rowId) => `${baseUrl}/rooftop_layer_interaction/${rowId}/`,
      layerList: (rooftopId) => `${layersUrl}/get_rooftop_layer_list_of_rooftop/?rooftop_id=${rooftopId}`,
      layerPost: () => `${baseUrl}/rooftop_layer_interaction/`,
      list: (projectId) => `${layersUrl}/get_rooftop_list_with_layers_of_project/?project_id=${projectId}`,
      post: () => `${baseUrl}/rooftop_interaction/`,
    },
    [techDataSections.WALL]: {
      detail: (rowId) => `${baseUrl}/facade_interaction/${rowId}/`,
      downloadAll: (projectId) =>
        `${layersUrl}/get_whole_files_of_envelop_type/?project_id=${projectId}&envelop_type=facade/`,
      downloadLayer: (projectId, layerId) =>
        `${layersUrl}/get_files_layer_zip_files_of_specific_envelop/?project_id=${projectId}&layer_id=${layerId}&layer_type=facade/`,
      layerDetail: (rowId) => `${baseUrl}/facade_layer_interaction/${rowId}/`,
      layerList: (facadeId) => `${layersUrl}/get_facade_layer_list_of_facade/?facade_id=${facadeId}`,
      layerPost: () => `${baseUrl}/facade_layer_interaction/`,
      list: (projectId) => `${layersUrl}/get_facade_list_with_layers_of_project/?project_id=${projectId}`,
      post: () => `${baseUrl}/facade_interaction/`,
    },
    [techDataSections.WINDOWS]: {
      detail: (rowId) => `${baseUrl}/windows_interaction/${rowId}/`,
      downloadAll: (projectId) =>
        `${layersUrl}/get_whole_files_of_envelop_type/?project_id=${projectId}&envelop_type=window/`,
      downloadLayer: (projectId, layerId) =>
        `${layersUrl}/get_files_layer_zip_files_of_specific_envelop/?project_id=${projectId}&layer_id=${layerId}&layer_type=window/`,
      layerDetail: (rowId) => `${baseUrl}/windows_layer_interaction/${rowId}/`,
      layerList: (windowId) => `${layersUrl}/get_window_layer_list_of_window/?window_id=${windowId}`,
      layerPost: () => `${baseUrl}/windows_layer_interaction/`,
      list: (projectId) => `${layersUrl}/get_windows_list_with_layers_of_project/?project_id=${projectId}`,
      post: () => `${baseUrl}/windows_interaction/`,
    },
  },
};
